import { campaignsSlice } from '../../campaigns';
import { TapiEndpointFactory } from '../baseQuery';

export const getCampaignHealthStatusEndpoint: TapiEndpointFactory<'V1CampaignsHealthStatusDetail'> =
  (builder) =>
    builder.query({
      query: ({ id: campaignId }) => `/campaigns/${campaignId}/health_status`,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const response = await queryFulfilled;
          dispatch(
            campaignsSlice.actions.campaignHealthStatusFetched(
              response.data.data.attributes
            )
          );
        } catch (error) {
          console.log(`error fetching health status ${error}`);
        }
      },
    });
